/**
 * @file clipboard.js
 * @description 剪贴板写入（复制链接等）
 * @module shared/utils/clipboard
 */

/**
 * 将文本写入剪贴板
 * @param {string} text
 * @returns {Promise<boolean>} 是否成功
 */
export async function copyTextToClipboard(text) {
  const value = typeof text === 'string' ? text.trim() : ''
  if (!value) return false

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value)
      return true
    } catch {
      /* 降级 execCommand */
    }
  }

  if (typeof document === 'undefined') return false

  try {
    const textarea = document.createElement('textarea')
    textarea.value = value
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch {
    return false
  }
}
